import { useState } from "react";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
// import "primereact/resources/themes/lara-light-blue/theme.css";
// import "primereact/resources/primereact.min.css";
// import "primeicons/primeicons.css";

const InterpretationForm = ({ currentProject, formData, setFromData }) => {
  function setLayers(newLayers) {
    setFromData((prev) => ({
      ...prev,
      layers:
        typeof newLayers === "function"
          ? newLayers(prev.layers || [])
          : newLayers,
    }));
  }

  function setApparitionRocher(value) {
    setFromData((prev) => ({
      ...prev,
      apparitionRocher: value,
    }));
  }

  function setApparitionNappe(value) {
    console.log(setFromData);
    setFromData((prev) => ({
      ...prev,
      apparitionNappe: value,
    }));
  }

  const textureOptions = (depth) => {
    // by default try to use the currentSondage.excel_texture if available
    if (currentProject.excel_texture) {
      return currentProject.excel_texture
        .filter((textureWithScore) => {
          if (depth < 2) {
            return textureWithScore[0].includes("(avant 2m)");
          }
          return textureWithScore[0].includes("(après 2m)");
        })
        .map((opt) => ({
          label: opt[0],
          value: opt[0],
        }))
        .sort((a, b) => a.label.localeCompare(b.label));
    } else {
      console.log("Alert! Using default hard coded texture options");
      const base = [
        "Grave [seul]",
        "Grave sable/sableux",
        "Sable grossier",
        "Alluvion(s) Grossier",
        "Alluvion(s) sable/sableux",
        "Sable moyen",
        "Sable [seul]",
        "Sable fin",
        "Alluvion(s) [seul]",
        "Tourbe sable/sableux",
        "Tourbe [seul]",
        "Sable molassique",
        "Sable gréseux",
        "Grave limon/limoneux",
        "Sable limon/limoneux",
        "Remblai [seul]",
        "Alluvion(s) fin",
        "Alluvion(s) limon/limoneux",
        "Tourbe limon/limoneux",
        "Limon sableux",
        "Silt sable/sableux",
        "Limon grossier",
        "Silt gréseux",
        "Limon moyen",
        "Limon tourbeux",
        "Limon fin",
        "Limon silteux",
        "Limon [seul]",
        "Silt [seul]",
        "Sable limono-argileux",
        "Sable limoneux argileux",
        "Limon sablo-argileux",
        "Limon sableux argileux",
        "Sable argilo-limoneux",
        "Sable argileux limoneux",
        "Alluvion(s) argile/argileux",
        "Grave argile/argileux",
        "Sable argile/argileux",
        "Tourbe limono-argileux",
        "Tourbe limoneux argileux",
        "Tourbe argile/argileux",
        "Limon argilo-sableux",
        "Limon argileux sableux",
        "Limon argile/argileux",
        "Silt argile/argileux",
        "Remblai morainique",
        "Argile ou Glaise sableux",
        "Argile ou Glaise tourbeux",
        "Argile ou Glaise sablo-limoneux",
        "Argile ou Glaise sableux limoneux",
        "Argile ou Glaise limon/limoneux",
        "Argile ou Glaise silteux",
        "Moraine [seul]",
        "Argile ou Glaise limono-sableux",
        "Argile ou Glaise limoneux sableux",
        "Argile ou Glaise [seul]",
        "Rocher  altéré",
        "Rocher  fissuré",
        "Rocher  [seul]",
      ];
      const value = depth < 2 ? " (avant 2m)" : " (après 2m)";
      return base.map((opt) => ({
        label: opt + value,
        value: opt + value,
      }));
    }
  };

  const squeletteOptions = () => {
    if (currentProject.excel_squelette) {
      return currentProject.excel_squelette
        .map((squeletteWithScore) => ({
          label: squeletteWithScore[0],
          value: squeletteWithScore[0],
        }))
        .sort((a, b) => a.label.localeCompare(b.label));
    } else {
      console.log("Alert! Using default hard coded squelette options");
      const base = [
        "Gravier(s)",
        "Graveleux",
        "très graveleux",
        "riche en graviers",
        "beaucoup de graviers",
        "nombreux graviers",
        "très pierreux",
        "riche en pierres",
        "beaucoup de pierres",
        "nombreuses pierres",
        "très caillouteux",
        "riche en cailloux",
        "beaucoup de cailloux",
        "nombreux cailloux",
        "riche en bloc(s)",
        "beaucoup de bloc(s)",
        "nombreux bloc(s)",
      ];
      return base.map((opt) => ({
        label: opt,
        value: opt,
      }));
    }
  };

  const compaciteOptions = () => {
    if (currentProject.excel_compacite) {
      return currentProject.excel_compacite
        .map((compaciteWithScore) => ({
          label: compaciteWithScore[0],
          value: compaciteWithScore[0],
        }))
        .sort((a, b) => a.label.localeCompare(b.label));
    } else {
      console.log("Alert! Using default hard coded compacite options");
      const base = [
        "Sable compact",
        "Sable très compact",
        "Limon compact",
        "Limon très compact",
        "Argile compact",
        "Argile très compact",
        "Sable dur",
        "Sable très dur",
        "Limon dur",
        "Limon très dur",
        "Argile dur",
        "Argile très dur",
        "Sable : arrêt forcé",
        "Limon : arrêt forcé",
        "Argile : arrêt forcé",
      ];
      return base.map((opt) => ({
        label: opt,
        value: opt,
      }));
    }
  };

  const handleAppChange = (index, value) => {
    setLayers((prev) => {
      const updated = [...prev];
      const numericValue = value ?? 0;

      // Always update the value
      updated[index].app = numericValue;

      // Update previous layer's disp if needed
      if (index > 0) {
        updated[index - 1].disp = numericValue;
      }

      return updated;
    });
  };

  const handleDispChange = (index, value) => {
    setLayers((prev) => {
      const updated = [...prev];
      updated[index].disp = value ?? null;
      if (index < updated.length - 1 && value !== null) {
        updated[index + 1].app = value;
      }
      return updated;
    });
  };

  const handleSelectChange = (index, field, value) => {
    setLayers((prev) => {
      const updated = [...prev];
      updated[index][field] = value ?? ""; // empty string if null or undefined
      return updated;
    });
  };

  const addLayer = () => {
    const last = formData.layers[formData.layers.length - 1];
    let newDisp = null;
    if (last.app === 1 && last.disp < 2) {
      newDisp = 2;
    }
    setLayers([
      ...formData.layers,
      {
        app: last.disp || 0.0,
        disp: newDisp,
        texture: "",
        squelette: "",
        compacite: "",
      },
    ]);
  };

  const removeLayer = (index) => {
    if (formData.layers.length <= 1) return;
    setLayers(formData.layers.filter((_, i) => i !== index));
  };

  const validateLayer = (layer, index) => {
    const errors = {};
    const isLastLayer = index === formData.layers.length - 1;

    // Validate apparition depth
    if (layer.app === null || layer.app === undefined || layer.app === "") {
      errors.app = "La profondeur est requise";
    } else if (layer.app < 0) {
      errors.app = "Doit être positive";
    } else if (index > 0 && layer.app <= formData.layers[index - 1].app) {
      errors.app = `Doit être > ${formData.layers[index - 1].app} m`;
    } else if (layer.app < 2 && layer.disp > 2) {
      errors.disp = "Il faut absolument faire une coupure à 2m!";
    }

    // Validate disappearance depth for last layer
    if (isLastLayer || true) {
      if (
        layer.disp === null ||
        layer.disp === undefined ||
        layer.disp === ""
      ) {
        errors.disp = "La profondeur de disparition est requise";
      } else if (layer.disp <= layer.app) {
        errors.disp = `Doit être > ${layer.app} m`;
      }
    }

    // Validate other fields
    if (!layer.texture) errors.texture = "Sélection requise";
    // if (!layer.squelette) errors.squelette = "Sélection requise";
    // if (!layer.compacite) errors.compacite = "Sélection requise";

    return errors;
  };

  // when scrolling down the dropdown, the body should not scroll
  const handleDropdownShow = () => {
    document.body.style.overflow = "hidden";
    document.getElementById("yolooo").style.overflow = "hidden";
  };

  const handleDropdownHide = () => {
    document.body.style.overflow = "";
    document.getElementById("yolooo").style.overflowY = "auto";
  };

  return (
    currentProject &&
    formData && (
      <div className="p-4 space-y-6 max-w-5xl mx-auto">
        {/* Apparition du rocher intput*/}

        <div className="p-6 border rounded-2xl shadow-md space-y-6 bg-white">
          <span
            className="flex items-center gap-4 leading-none text-gray-800"
            style={{ fontWeight: "bold" }}
          >
            Apparition du rocher
          </span>
          <InputNumber
            value={formData.apparitionRocher}
            onChange={(e) => setApparitionRocher(e.value)}
            placeholder="Profondeur d'apparition (m)"
            className="w-full p-3 rounded-lg focus:ring-2 focus:ring-blue-200 focus:border-blue-500"
            style={{ width: "276px", paddingTop: "5px", paddingBottom: "5px" }}
            buttonLayout="horizontal"
            incrementButtonIcon="pi pi-plus"
            decrementButtonIcon="pi pi-minus"
            minFractionDigits={1}
            maxFractionDigits={2}
            showButtons={true}
            step={1.0}
            readOnly={false}
          />
        </div>

        {/* Apparition de la nappe */}
        <div
          className="p-6 border rounded-2xl shadow-md space-y-6 bg-white"
          style={{ paddingBottom: "15px" }}
        >
          <span
            className="flex items-center gap-4 leading-none text-gray-800"
            style={{ fontWeight: "bold" }}
          >
            Apparition de la nappe
          </span>
          <InputNumber
            value={formData.apparitionNappe}
            onChange={(e) => setApparitionNappe(e.value)}
            placeholder="Profondeur d'apparition (m)"
            className="w-full p-3 rounded-lg focus:ring-2 focus:ring-blue-200 focus:border-blue-500"
            style={{ width: "276px", paddingTop: "5px", paddingBottom: "5px" }}
            buttonLayout="horizontal"
            incrementButtonIcon="pi pi-plus"
            decrementButtonIcon="pi pi-minus"
            minFractionDigits={1}
            maxFractionDigits={2}
            showButtons={true}
            step={1}
            readOnly={false}
          />
        </div>

        {formData.layers.map((layer, i) => {
          const errors = validateLayer(layer, i);
          const isLastLayer = i === formData.layers.length - 1;
          const hasErrors = Object.keys(errors).length > 0;

          return (
            <div
              key={i}
              className={`p-6 border rounded-2xl shadow-md space-y-6 bg-white ${
                hasErrors ? "border-red-300" : "border-gray-200"
              }`}
              style={{ paddingBottom: "15px" }}
            >
              {/* Couche title with trash button for 3rd and more */}
              <span
                className="flex items-center gap-4 leading-none text-gray-800"
                style={{ fontWeight: "bold" }}
              >
                Couche {i + 1}{" "}
                <span className="text-sm font-normal text-gray-500">
                  (Intervalle de {layer.app} à {layer.disp || "?"} m)
                </span>
                {i > 0 && (
                  <Button
                    icon="pi pi-trash"
                    className="p-button-rounded p-button-danger p-button-text ml-2"
                    onClick={() => removeLayer(i)}
                    tooltip={"Supprimer cette couche " + (i + 1)}
                    tooltipOptions={{ position: "bottom" }}
                    style={{ paddingTop: "9px", height: "10px" }}
                  />
                )}
              </span>

              <div
                className={`grid grid-cols-1 md:grid-cols-${isLastLayer ? 5 : 4} gap-6`}
              >
                {/* Apparition Field */}
                {i >= 0 && (
                  <div className="flex flex-col gap-2">
                    <label
                      className="block text-sm font-medium text-gray-700 mb-1"
                      style={{ paddingRight: "10px" }}
                    >
                      Apparition (m)
                    </label>
                    <InputNumber
                      value={layer.app}
                      onValueChange={(e) => handleAppChange(i, e.value)}
                      minFractionDigits={1}
                      maxFractionDigits={2}
                      inputClassName={`w-full p-3 rounded-lg focus:ring-2 focus:ring-blue-200 focus:border-blue-500 ${
                        errors.app ? "border-red-500" : "border-gray-300"
                      }`}
                      className={errors.app ? "p-invalid" : ""}
                      inputStyle={{ width: "200px" }}
                      buttonLayout="horizontal"
                      incrementButtonIcon="pi pi-plus"
                      decrementButtonIcon="pi pi-minus"
                      showButtons={true}
                      disabled={true}
                      tooltip={
                        i === 0
                          ? "ça commence à 1m"
                          : "Profondeur d'apparition = disparition de la couche précédente"
                      }
                      step={1}
                    />
                    {errors.app && (
                      <small style={{ color: "red" }}>
                        <br />
                        {errors.app}
                      </small>
                    )}
                  </div>
                )}

                {/* Disparition Field for Last Layer */}
                {(isLastLayer || true) && (
                  <div className="flex flex-col gap-2">
                    <label
                      className="block text-sm font-medium text-gray-700 mb-1"
                      style={{ paddingRight: "7px" }}
                    >
                      Disparition (m)
                    </label>
                    <InputNumber
                      value={layer.disp}
                      onValueChange={(e) => handleDispChange(i, e.value)}
                      minFractionDigits={1}
                      maxFractionDigits={2}
                      inputClassName={`w-full p-3 rounded-lg focus:ring-2 focus:ring-blue-200 focus:border-blue-500 ${
                        errors.disp ? "border-red-500" : "border-gray-300"
                      }`}
                      className={errors.disp ? "p-invalid" : ""}
                      showButtons
                      inputStyle={{ width: "200px" }}
                      buttonLayout="horizontal"
                      incrementButtonIcon="pi pi-plus"
                      decrementButtonIcon="pi pi-minus"
                      disabled={false}
                      tooltip={""}
                      step={1}
                    />
                    {errors.disp && (
                      <small style={{ color: "red" }}>
                        <br />
                        {errors.disp}
                      </small>
                    )}
                  </div>
                )}

                {/* Texture Field */}
                <div className="flex flex-col gap-2">
                  <label
                    className="block text-sm font-medium text-gray-700 mb-1"
                    style={{ paddingRight: "60px" }}
                  >
                    Texture
                  </label>
                  <Dropdown
                    value={layer.texture}
                    options={textureOptions(layer.app)}
                    onChange={(e) => handleSelectChange(i, "texture", e.value)}
                    placeholder="Sélectionnez"
                    className={`w-full ${errors.texture ? "p-invalid" : ""}`}
                    panelClassName="rounded-lg shadow-lg"
                    scrollHeight={i === 0 ? "400px" : "600px"}
                    style={{ width: "276px" }}
                    filterInputAutoFocus={true}
                    appendTo={null}
                    onShow={handleDropdownShow}
                    onHide={handleDropdownHide}
                    filter
                  />
                  {/*{errors.texture && (*/}
                  {/*  <small style={{ color: "red" }}>*/}
                  {/*    {errors.texture}*/}
                  {/*  </small>*/}
                  {/*)}*/}
                </div>

                {/* Squelette Field */}
                <div className="flex flex-col gap-2">
                  <label
                    className="block text-sm font-medium text-gray-700 mb-1"
                    style={{ paddingRight: "45px" }}
                  >
                    Squelette
                  </label>
                  <Dropdown
                    value={layer.squelette}
                    options={squeletteOptions()}
                    onChange={(e) =>
                      handleSelectChange(i, "squelette", e.value)
                    }
                    placeholder="Sélectionnez" // optionnel
                    className={`w-full ${errors.squelette ? "p-invalid" : ""}`}
                    panelClassName="rounded-lg shadow-lg"
                    scrollHeight={"400px"}
                    style={{ width: "276px" }}
                    filterInputAutoFocus={true}
                    filter
                    showClear
                    defaultValue={""}
                    appendTo={null}
                    onShow={handleDropdownShow}
                    onHide={handleDropdownHide}
                  />
                  {/*{errors.squelette && (*/}
                  {/*  <small style={{ color: "red" }}>*/}
                  {/*    {errors.squelette}*/}
                  {/*  </small>*/}
                  {/*)}*/}
                </div>

                {/* Compacité Field */}
                <div className="flex flex-col gap-2">
                  <label
                    className="block text-sm font-medium text-gray-700 mb-1"
                    style={{ paddingRight: "35px" }}
                  >
                    Compacité
                  </label>
                  <Dropdown
                    value={layer.compacite}
                    options={compaciteOptions()}
                    onChange={(e) =>
                      handleSelectChange(i, "compacite", e.value)
                    }
                    placeholder="Sélectionnez" // (optionnel)
                    className={`w-full ${errors.compacite ? "p-invalid" : ""}`}
                    panelClassName="rounded-lg shadow-lg"
                    scrollHeight={"400px"}
                    style={{ width: "276px" }}
                    filterInputAutoFocus={true}
                    filter
                    showClear
                    defaultValue={""}
                    appendTo={null}
                    onShow={handleDropdownShow}
                    onHide={handleDropdownHide}
                  />
                  {/*{errors.compacite && (*/}
                  {/*  <small style={{ color: "red" }}>*/}
                  {/*    {errors.compacite}*/}
                  {/*  </small>*/}
                  {/*)}*/}
                </div>
              </div>
            </div>
          );
        })}

        <div
          className="flex justify-center mt-4"
          style={{ paddingTop: "5px", paddingBottom: "20px" }}
        >
          <Button
            label="Ajouter une couche"
            onClick={addLayer}
            icon="pi pi-plus"
            className="p-button-rounded p-button-outlined p-button-primary"
          />
        </div>
      </div>
    )
  );
};

export default InterpretationForm;
